import { Title } from '@bpm-web-app/components';
import { Presets } from '@bpm-web-app/components/pages';
import { Banner } from '@bpm-web-app/components/src/lib/shared';

export default function presetPage({ title }: { title: string }) {
    return (
        <>
            <Title platform="create" title={title} />
            <Banner platform="create" location="presets" variant="hidden" />
            <Presets />
        </>
    );
}

export async function getStaticProps() {
    return {
        props: {
            title: 'Synth Presets'
        }
    };
}
